import * as React from 'react';

import { translate } from '~l10n/client';

import { ImageUploadContext } from '~analytics/adapters/ImageEventAdapterTypes';
import ImageField from '~shared/components/ImageField/ImageField';
import { QuizEditorIsUploadingImageContext } from '~teacher/components/QuizEditor/QuizEditorIsUploadingImage';
import { ImageResource } from '~teacher/models/quizzes';

interface QuestionImageEditingProps {
  image?: ImageResource;
  /** is the question in Disabled mode? */
  isDisabled?: boolean;
  /** Callback action when the image is changed or removed. */
  onChangeImage?: (imageURL: string) => void;
  onBeginUploadingImage?: () => void;
  onFinishUploadingImage?: () => void;
}

export function QuestionImageEditing({
  image = null,
  isDisabled = false,
  onChangeImage,
  onBeginUploadingImage,
  onFinishUploadingImage,
}: QuestionImageEditingProps) {
  const imageURL = image?.urlS ?? image?.url;
  const imageValue = imageURL ? [imageURL] : null;

  if (isDisabled) return null;

  return (
    <QuizEditorIsUploadingImageContext.Consumer>
      {({ beginUploading, finishUploading }) => (
        <ImageField
          context={ImageUploadContext.Question}
          className="bg-transparent hover:bg-cyan-50 focus:bg-cyan-50 group-focus-within:bg-cyan-50"
          initialImages={imageValue}
          onBeginUploadingImage={() => {
            onBeginUploadingImage?.();
            beginUploading();
          }}
          onFinishUploadingImage={() => {
            onFinishUploadingImage?.();
            finishUploading();
          }}
          labelText={translate('Question Image')}
          clearLabel={translate('Remove Question Image')}
          onUpdateImage={(imageURL) => {
            onChangeImage?.(imageURL);
          }}
        />
      )}
    </QuizEditorIsUploadingImageContext.Consumer>
  );
}
